export default {
  state: {
    activeRoute: 'home'
  },
  mutations: {
    SET_ACTIVE_ROUTE(state, routeName) {
      state.activeRoute = routeName
    }
  },
  actions: {
    updateActiveRoute({ commit }, routeName) {
      commit('SET_ACTIVE_ROUTE', routeName)
    }
  }
} 